import { Spinner } from 'shared/ui/spinner';

import styles from './styles.module.scss';

export type AssignmentActionsMenuOptionProps = {
  optionName: string;
  onClick: () => void;
  onContextMenu?: () => void;
  withLoadingSpinner?: boolean;
};

export const AssignmentActionsMenuOption = ({
  optionName,
  onClick,
  onContextMenu,
  withLoadingSpinner,
}: AssignmentActionsMenuOptionProps) => {
  return (
    <button
      className={styles.optionBtn}
      onClick={onClick}
      onContextMenu={onContextMenu}
      data-testid="assignment-actions-menu-option"
    >
      {optionName}
      <span
        className={styles.loadingSpinner}
        data-testid="option-loading-spinner"
      >
        {withLoadingSpinner && <Spinner isCentered={false} isDark />}
      </span>
    </button>
  );
};
